//
import Routers from "./routes/Routers";
import "./Style/style.css";
import "./App.css";
import ScrollToTop from "./Components/ScrollToTop";

function App() {
  return (
    <>
      <ScrollToTop />
      <Routers />
    </>
  );
}

export default App;
